exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "a {\n  color: #17181a;\n  width: 40px;\n  height: 40px;\n  line-height: 40px;\n  text-align: center;\n  border: none; }\n  a span {\n    font-size: 24px; }\n\n.ui-widget-header {\n  border: none;\n  background: #ffffff 0 0 repeat-x;\n  background: linear-gradient(to bottom, #ffffff 0%, #ffffff 100%); }\n\n.ui-paginator-first,\n.ui-paginator-last {\n  display: none; }\n\n.ui-state-active {\n  background: #14CC9E !important;\n  color: #ffffff;\n  border-color: #14CC9E !important; }\n\n.ui-paginator-pages > a {\n  margin: 0 5px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /data/wwwroot/xzhipin/app-client/src/app/shared/page-index/page-index.component.scss
// module id = ../../../../../src/app/shared/page-index/page-index.component.scss
// module chunks = main